import { useState, useRef, useContext } from 'react';
import {Link, useNavigate} from 'react-router-dom';

import AuthContext, {isAdminRole, adminRoleConstant, nonAdminRoleConstant} from '../../store/auth-context';
import {getBackendURL} from '../../common/Backend';
import {getMyIdentity} from '../../common/BackendConnections';
import classes from './AuthForm.module.css';


const AuthForm = () => {
  const backendUrl = getBackendURL();
  const navigate = useNavigate();
  const usernameInputRef = useRef();
  const passwordInputRef = useRef();

  const authCtx = useContext(AuthContext);

  // const [isLogin, setIsLogin] = useState(true);  // Use state to manage login/signup
  const isLogin = true
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const submitHandler = (event) => {
    event.preventDefault();

    const enteredUsername = usernameInputRef.current.value;
    const enteredPassword = passwordInputRef.current.value;

    // optional: Add validation

    setIsLoading(true);
    setMessage("");

    let url;
    let body;
    let headers;
    let details = {
      'username': enteredUsername,
      'password': enteredPassword,
      //'grant_type': 'password'
    };

    let formBody = [];
    for (let property in details) {
      let encodedKey = encodeURIComponent(property);
      let encodedValue = encodeURIComponent(details[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    url = backendUrl+'/unltd/cookie/login';
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      'accept': 'application/json'
    };
    body = formBody;

    fetch(url, {
      method: 'POST',
      'credentials': "include",
      body: body,
      headers: headers
    })
      .then((res) => {
        setIsLoading(false);
        if (res.ok) {
          return res.json();
        } else {
          return res.json().then((data) => {
            let errorMessage = 'Authentication failed!';
             if (data && data.error && data.error.message) {
               errorMessage = data.error.message;
             }

            throw new Error(errorMessage);
          });
        }
      })
      .then((data) => {
        setMessage("Login succeeded!");
        // console.debug(data);
        if (data.access_token) {
          console.log("Successful user login");
          const expirationTime = new Date(
            new Date().getTime() + 3600 * 1000
          );

          /*
          * data.access_token should be set to "cookie" by the server
          * expirationTime must be an int with milliseconds units
          * The server will also return the user full name in next version
          * */
          // authCtx.login(data.access_token, expirationTime.getTime());
          getMyIdentity().then((response) => {
              //console.debug(response);
              const user_full_name = response.data.given_name + ' ' + response.data.family_name;

              if (isAdminRole(response.data.web_role)) {
                authCtx.login("cookie", expirationTime.getTime(), response.data.user_id, user_full_name, adminRoleConstant);
                navigate("/admin/");
              } else {
                authCtx.login("cookie", expirationTime.getTime(), response.data.user_id, user_full_name, nonAdminRoleConstant);
                navigate("/patient_selection/");
              }
            }
          ).catch((error) => {
            console.debug(error);
            setMessage(error.message);
          });
        } else {
          console.log("user login failed");
        }
      })
      .catch((err) => {
        console.debug(err);
        setMessage("Login Failed!");
        setIsLoading(false);
      });
  };

  return (
    <section className={"page_content"} style={{marginTop: "15vh"}}>
      <div className={classes.auth}>
        <h1 style={{fontWeight:'bold', marginBottom: '.5em'}}>{isLogin ? 'Sign In' : 'Sign Up'}</h1>
        <img className={classes.logo} src="/images/UNLTDTHERA_CONNECT_V2.png" alt="Unlimited therapy logo" />
        <form onSubmit={submitHandler} style={{marginTop: '2em'}}>
          <div className={classes.control}>
            <label htmlFor='username'>Username</label>
            <input type='text' id='username' required ref={usernameInputRef}
              autoComplete={"username"} />
          </div>
          <div className={classes.control}>
            <label htmlFor='password'>Password</label>
            <input
              type='password'
              id='password'
              required
              ref={passwordInputRef}
              autoComplete={"password"}
            />
          </div>
          <div className={"text-end"}>
            <Link to={"/forgotpassword/"}>Forgot Password?</Link>
          </div>
          <div>{message}</div>
          <div className={classes.actions}>
            {!isLoading && (
              <button className={"text-capitalize"}>{isLogin ? 'Sign In' : 'Create Account'}</button>
            )}
            {isLoading && <p>Sending request...</p>}

            <span>
              Don't have an account?
              <Link to={"/help/"} style={{marginLeft: '.5em'}}>Get Help</Link>
            </span>
          </div>
        </form>
      </div>
    </section>
  );
};

export default AuthForm;
